import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, FunctionField, ReferenceField, TextField } from 'react-admin';
import List from 'components/List';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';
import { scopeLabel } from 'utils/hrisMappingHelpers';

const HrisSpecialtyMappingList = () => (
  <List exporter={false}>
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <IdField />
      <ReferenceField
        label="Company"
        source="company_id"
        reference="Company"
        link="show"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField label="Scope" render={scopeLabel} />
      <ReferenceField
        label="Location"
        source="location_id"
        reference="Location"
        link="show"
        sortable={false}
        emptyText="-"
      >
        <TextField source="name" />
      </ReferenceField>
      <LinkField label="Specialty" source="specialty.label" sortable={false} />
      <TextField label="External ID" source="external_id" sortable={false} />
    </Datagrid>
  </List>
);

HrisSpecialtyMappingList.query = gql`
  query hrisSpecialtyMappings($input: HrisSpecialtyMappingQueryInput) {
    _hrisSpecialtyMappingsMeta(input: $input) {
      count
    }
    hrisSpecialtyMappings(input: $input) {
      id
      company_id
      location_id
      external_id
      specialty {
        id
        label
      }
    }
  }
`;

export default HrisSpecialtyMappingList;
